import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { Leaderboard } from "@low6dev/react-feature-leaderboard/dist";
import { handleError } from "@low6dev/react-utils/dist";
import history from "router/history";
import { useTranslations } from "hooks";
import { setBetbarParent } from "components/feature/betbar/actions";

const StyledWrapper = styled.div`
  padding: 1rem;
`;

const Wrapper = () => {
  const dispatch = useDispatch();

  const app = useSelector((s) => s.app);

  const [translations] = useTranslations();

  const betbarParent = useSelector((s) => s.betbarParent);

  const handleSetBetbarParent = (betbar) => {
    dispatch(setBetbarParent(betbar));
  };

  return (
    <StyledWrapper>
      <Leaderboard
        translations={translations}
        history={history}
        onError={handleError}
        isExample
        betbarParent={betbarParent}
        setBetbarParent={handleSetBetbarParent}
        app={app}
        isUsingAlternativeImages
        hidePrizeMoney={process.env.REACT_APP_HIDE_PRIZE_MONEY === "true"}
        showPrizeIconIfAllQuestionsCorrect={
          process.env.REACT_APP_SHOW_PRIZE_ICON_ALL_QUESTIONS_CORRECT === "true"
        }
        showPrizeIconIfAllButOneQuestionsCorrect={
          process.env
            .REACT_APP_SHOW_PRIZE_ICON_ALL_BUT_ONE_QUESTIONS_CORRECT === "true"
        }
        showPrizeIcons
      />
    </StyledWrapper>
  );
};

export default Wrapper;
